import { useState, Suspense, lazy, useEffect, useCallback } from "react";
import * as global from '../data/global';
import { MuiMaterials } from "../@index";
import BinThermoIcon from '@mui/icons-material/DeviceThermostat';
import * as THREE from 'three';
import { createApiEndpoint } from '../index.js';

//const loader = new THREE.TextureLoader();
//const smokeTexture = loader.load('../assets/images/smoke.jpg');
//smokeTexture.wrapS = THREE.RepeatWrapping;
//smokeTexture.wrapT = THREE.RepeatWrapping;
//smokeTexture.repeat.set(4, 4)

export const Thermo = () => {
    const [loading, setLoading] = useState(false);
    const [forceUpdate, setForceUpdate] = useState(0);

    // Helper function to get theme-aware colors (reads directly from global.gw.theme)
    const getThemeColor = useCallback((lightColor, darkColor) => {
        if (global.gw.theme === 'light') {
            return lightColor;
        }
        return darkColor;
    }, []);

    // Listen for theme changes - only trigger re-render when theme actually changes
    useEffect(() => {
        const handleThemeChange = () => {
            setForceUpdate(prev => prev + 1);
        };
        window.addEventListener('themeChanged', handleThemeChange);
        return () => window.removeEventListener('themeChanged', handleThemeChange);
    }, []);

    const handleTestClick = (e) => {
        setLoading(true);
        let target = e.currentTarget;
        if (!global.gw.selectedSite.showBinThermo) {
            global.gw.selectedSite.showBinThermo = true;
        }
        else {
            global.gw.selectedSite.showBinThermo = false;
        }

        let today = new Date();
        let selectedDate = window.document.getElementsByClassName("dateLabel")[0];
        if (selectedDate) {
            today = new Date(selectedDate.textContent);
        }

        let dateFrom = new Date(today.toJSON().split("T")[0] + "T00:00:00.000Z");
        let dateTo = new Date(today.toJSON().split("T")[0] + "T00:00:00.000Z");
        let grainLevelPositions = [];
        //if ((selectedDate && global.gw.selectedSite.grainLevelsDateFrom !== selectedDate.textContent) || global.gw.selectedSite.grainLevels.length === 0) {
        global.gw.selectedSite.grainLevels = [];
        const ctask = () => {
            return createApiEndpoint().fetchGetSiteGrainLevels("compressed", null, null, null, null, null, null, dateFrom, dateTo, 0, 24, true, 5);
        };
        ctask().then(async (response) => {
            global.gw.selectedSite.binMeshes = [];
            if (response && response.data && response.data.fetchGetSiteGrainLevels) {
                global.gw.selectedSite.grainLevels = response.data.fetchGetSiteGrainLevels;
                response.data.fetchGetSiteGrainLevels.map(s => {
                    if (s.temperature !== "-E-") {
                        grainLevelPositions.push(global.toggleCableLevelRef(s.binId, s.cableId, s.sensorId, s.position));
                    }
                });
                global.renderGrainLevels(grainLevelPositions);

                const tasks = [];
                let interval = setInterval(() => {
                    setLoading(false);
                    clearInterval(interval);
                    global.gw.selectedSite.grainLevelsDateFrom = selectedDate.textContent;
                    const isLight = global.gw.theme === 'light';
                    if (global.gw.selectedSite.showBinThermo) {
                        target.style.color = isLight ? "#333333" : "#f4cc8e";
                    }
                    else {
                        target.style.color = isLight ? "#33333361" : "#f4cc8e61";
                    }
                }, 500);

                for await (const sensorGroupRef of global.gw.selectedSite.sensorsGroupRef) {
                    if (sensorGroupRef.meshProps.material.color &&
                        !(sensorGroupRef.meshProps.material.color.r === 0.8 &&
                            sensorGroupRef.meshProps.material.color.b === 0.8 &&
                            sensorGroupRef.meshProps.material.color.g === 0.8)) {

                        //let grainLevelSensor = grainLevelPositions.filter(x => x.binId === sensorGroupRef.meshProps.binId && x.cableId === sensorGroupRef.meshProps.cableId && x.sensorId >= sensorGroupRef.meshProps.sensorId);
                        //if (grainLevelSensor && grainLevelSensor.length > 0) {
                        //    //tasks.push(s.handleThermo(global.gw.selectedSite.showBinThermo, binMeshes, binBoundingBoxes));

                            setTimeout(() => {
                                sensorGroupRef.handleThermo(global.gw.selectedSite.showBinThermo, global.gw.selectedSite.binMeshes, global.gw.selectedSite.binBoundingBoxes);
                            }, 1);
                        //}
                    }

                    //Promise.all(tasks).then(() => {
                    //    setLoading(false);
                    //});
                }
            }
            //setLoading(false);
        }).catch((error) => {
            const isLight = global.gw.theme === 'light';
            target.style.color = isLight ? "#33333361" : "#f4cc8e61";
            global.gw.selectedSite.showGrainLevels = false
            setLoading(false);
        });
    };

    const handleThermoClick = async (e) => {
        setLoading(true);

        let target = e.currentTarget;

        if (!global.gw.selectedSite.showBinThermo) {
            global.gw.selectedSite.showBinThermo = true;
        }
        else {
            global.gw.selectedSite.showBinThermo = false;
        }

        if (global.gw.selectedSite.showBinThermo) {
            let today = new Date();

            let selectedDate = window.document.getElementsByClassName("dateLabel")[0];
            if (selectedDate) {
                let month = selectedDate.innerText.substring(0, 2);
                let day = selectedDate.innerText.substring(3, 5);
                let year = "20" + selectedDate.innerText.substring(6, 8);
                //alert(`${year}-${month}-${day}T00:00:00.000Z`);
                today = new Date(`${year}-${month}-${day}T00:00:00.000`);
                //alert(today);
            }

            let dateFrom = today;
            let dateTo = today;

            let grainLevelPositions = [];
            //if ((selectedDate && global.gw.selectedSite.grainLevelsDateFrom !== selectedDate.textContent) || global.gw.selectedSite.grainLevels.length === 0) {
            global.gw.selectedSite.grainLevels = [];

            const ctask = () => {
                return createApiEndpoint().fetchGetSiteGrainLevels("compressed", null, null, null, null, null, null, dateFrom, dateTo, 0, 24, true, 5);
            };
            ctask().then(async (response) => {
                global.gw.selectedSite.binMeshes = [];
                if (response && response.data && response.data.fetchGetSiteGrainLevels) {
                    global.gw.selectedSite.grainLevels = response.data.fetchGetSiteGrainLevels;
                    response.data.fetchGetSiteGrainLevels.map(s => {
                        if (s && s.temperature !== "-E-") {
                            if (global.gw.selectedSite.selectedBinId === 0 || (global.gw.selectedSite.selectedBinId > 0 && s.binId === global.gw.selectedSite.selectedBinId)) {
                                grainLevelPositions.push(global.toggleCableLevelRef(s.binId, s.cableId, s.sensorId, s.position));
                            }
                        }
                    });

                    global.renderGrainLevels(grainLevelPositions);

                    const tasks = [];
                    let interval = setInterval(() => {
                        setLoading(false);
                        clearInterval(interval);
                        global.gw.selectedSite.grainLevelsDateFrom = selectedDate.textContent;
                        const isLight = global.gw.theme === 'light';
                        if (global.gw.selectedSite.showBinThermo) {
                            target.style.color = isLight ? "#333333" : "#f4cc8e";
                        }
                        else {
                            target.style.color = isLight ? "#33333361" : "#f4cc8e61";
                        }
                    }, 500);

                    for await (const sensorGroupRef of global.gw.selectedSite.sensorsGroupRef) {
                        if (sensorGroupRef.meshProps.material.color &&
                            !(sensorGroupRef.meshProps.material.color.r === 0.8 &&
                                sensorGroupRef.meshProps.material.color.b === 0.8 &&
                                sensorGroupRef.meshProps.material.color.g === 0.8)) {

                            //let grainLevelSensor = grainLevelPositions.filter(x => x.binId === sensorGroupRef.meshProps.binId && x.cableId === sensorGroupRef.meshProps.cableId && x.sensorId >= sensorGroupRef.meshProps.sensorId);
                            //if (grainLevelSensor && grainLevelSensor.length > 0) {

                            //const task = async () => {
                            //    await setTimeout(async () => {
                            //        await renderSensorParticles(p);
                            //    }, 1);
                            //};
                            //tasks.push(task);

                            //tasks.push(renderSensorParticles(p));

                            setTimeout(() => {
                                global.renderSensorParticles(sensorGroupRef);
                            }, 1);

                            //const task = () => {
                            //Promise.resolve().then(renderSensorParticles(p));
                            //};

                            //tasks.push(task);


                            //renderSensorParticles(p);

                            //}
                        }
                    }

                    //Promise.all(tasks).then((models) => {
                    //    models.forEach(model => global.gw.selectedSite.sceneRef.add(model));
                    //});

                    //Promise.all(tasks).then(() => {
                    //    setLoading(false);
                    //});

                }
                //setLoading(false);
                //throw new Error('Test error!')
        }).catch((error) => {
            const isLight = global.gw.theme === 'light';
            target.style.color = isLight ? "#33333361" : "#f4cc8e61";
            global.gw.selectedSite.showGrainLevels = false
            setLoading(false);
            //alert(error);
        });

            //target.style.color = isLight ? "#333333" : "#f4cc8e";
        }
        else {
            //global.gw.selectedSite.showBinThermo = false;
            const isLight = global.gw.theme === 'light';
            target.style.color = isLight ? "#33333361" : "#f4cc8e61";

            global.gw.selectedSite.binsRef.map(b => {
                //for (let i = 0; i < b.children.length; i++) {
                //    let child = b.children[i];
                //    if (b.children[i].isMesh) {
                //        b.remove(child);
                //        i--;
                //    }
                //}
                try {
                    for (let i = 0; i < b.parent.parent.parent.children.length; i++) {
                        let child = b.parent.parent.parent.children[i];
                        //if (child.isGrainLight) {
                        //    b.parent.parent.parent.remove(child);
                        //    i--;
                        //}
                        //else
                        if (child.isParticle) {
                            b.parent.parent.parent.remove(child);
                            i--;
                        }
                    }
                } catch (error) {
                    
                }
            });

            //global.gw.selectedSite.binsRef.map(b => {
            //    for (let i = 0; i < b.parent.parent.parent.children.length; i++) {
            //        let child = b.parent.parent.parent.children[i];
            //        if (child.isParticle) {
            //            b.parent.parent.parent.remove(child);
            //            i--;
            //        }
            //    }
            //});
            setLoading(false);
        }

    };

    return (
        <MuiMaterials.Box style={{ margin: "0px" }}>
            <MuiMaterials.Tooltip title="Toggles Heat Map" arrow>
                <MuiMaterials.Button
                    type="button"
                    //loading={loading}
                    disabled={loading}
                    size="medium"
                    key={`thermo-button-${global.gw.theme}-${forceUpdate}`}
                    sx={{
                        color: getThemeColor('#33333361', '#f4cc8e61'),
                        margin: "auto",
                        maxWidth: "30px",
                        maxHeight: "40px",
                        minWidth: "30px",
                        minHeight: "40px",
                        '&:hover': {
                            backgroundColor: getThemeColor('#f5f5f5', '#3d3d3d'),
                        },
                        '& .MuiSvgIcon-root': {
                            color: getThemeColor('#33333361', '#f4cc8e61'),
                        },
                        '& .bti': {
                            color: getThemeColor('#33333361', '#f4cc8e61'),
                        },
                    }}
                    onClick={handleThermoClick}
                >
                    {loading ?
                        <MuiMaterials.RotatingLines
                            strokeColor={getThemeColor('#333333', '#f4cc8e')}
                            strokeWidth="3"
                            animationDuration="0.72"
                            width="48"
                            visible={true}
                        />
                        :
                        <BinThermoIcon className="bti" />
                    }
                </MuiMaterials.Button>
            </MuiMaterials.Tooltip>
        </MuiMaterials.Box>
    );
}

export default Thermo;

//const TestAsync = lazy(() => import('./TestAsync'));
//let items = global.gw.selectedSite.binsRef.map((b, i) => {
//    if (b.layoutBin.binId) {
//        return {
//            id: i,
//            binId: b.layoutBin.binId,
//            name: b.layoutBin.binName,
//            binRef: b,
//        }
//    }
//});

//items.map(x => (
//    <Suspense key={x.id} fallback={<div>Loading...</div>}>
//        <TestAsync item={x} />
//    </Suspense>
//))